// This class used for managing featured image resizing
function FeaturedImage() {
    this.extends = [_ResponsiveLayout, _Helpers, _ContentLayout];
    this.node = null;
    this.id = null;
    this.declaredClass = null;

    this._imageRatio = 0.46206897; // this value also in Search.js and PopularPosts.js

    this.init = function() {
        $(this.node).css("display", "block");
        this.registerResponsiveFunction($.proxy(this.resize, this), null, null);
    };

    this.initAllReady = function() {};

    this.resize = function() {
        var height = $(this.node).outerWidth() * this._imageRatio;
        $(this.node).css("height", height + "px");
    };

    this.reLayout = function() {
        this.resize();
    };
}